import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var scrollStyles = {
  overflowX: 'auto',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '@media print': {
    position: 'relative',
    overflowX: 'visible'
  },
  '::-webkit-scrollbar': {
    width: 0,
    height: 0
  }
};
export var defaultVariant = {
  header: _objectSpread({
    backgroundColor: 'surfaceSecondary',
    borderBottomColor: 'separatorTertiary',
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,
    position: 'sticky',
    top: 0,
    zIndex: 10
  }, scrollStyles),
  headerRow: {
    display: 'flex',
    minHeight: '48px',
    backgroundColor: 'inherit'
  },
  headerCell: function headerCell(_ref) {
    var isSortable = _ref.isSortable;
    return {
      boxSizing: 'content-box',
      display: 'flex',
      alignItems: 'center',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
      padding: '0 16px',
      backgroundColor: 'inherit',
      cursor: isSortable ? 'pointer' : 'default',
      outline: 0
    };
  },
  footer: _objectSpread({
    backgroundColor: 'surfaceSecondary',
    borderTopColor: 'separatorTertiary',
    borderTopStyle: 'solid',
    borderTopWidth: 1
  }, scrollStyles),
  footerRow: {
    display: 'flex',
    backgroundColor: 'inherit'
  },
  footerCell: {
    boxSizing: 'content-box',
    display: 'flex',
    alignItems: 'center',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    padding: '0 16px',
    whiteSpace: 'nowrap',
    backgroundColor: 'inherit',
    fontSize: 14
  },
  body: {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    '@media print': {
      overflowX: 'visible'
    }
  },
  bodyRow: function bodyRow(_ref2) {
    var firstRow = _ref2.firstRow,
        isLink = _ref2.isLink;
    return {
      display: 'flex',
      minHeight: '64px',
      color: 'inherit',
      backgroundColor: 'surface',
      borderTopColor: firstRow ? undefined : 'separatorTertiary',
      borderTopStyle: firstRow ? undefined : 'solid',
      borderTopWidth: firstRow ? undefined : 1,
      cursor: isLink ? 'pointer' : undefined,
      '&:focus': {
        outline: 'none'
      },
      '&:hover': isLink ? {
        backgroundColor: 'linkBackground'
      } : undefined
    };
  },
  bodyCell: {
    boxSizing: 'content-box',
    display: 'flex',
    alignItems: 'center',
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    padding: '0 16px',
    whiteSpace: 'nowrap',
    backgroundColor: 'inherit',
    fontSize: 14
  },
  bodySubRow: function bodySubRow(_ref3) {
    var isLink = _ref3.isLink;
    return {
      display: 'flex',
      minHeight: '44px',
      color: 'inherit',
      borderTopColor: 'separatorTertiary',
      borderTopStyle: 'solid',
      borderTopWidth: 1,
      backgroundColor: 'surfaceSecondary',
      cursor: isLink ? 'pointer' : undefined,
      '&:focus': {
        outline: 'none'
      },
      '&:hover': isLink ? {
        backgroundColor: 'linkBackground'
      } : {}
    };
  },
  bodySubCell: function bodySubCell(_ref4) {
    var firstRow = _ref4.firstRow,
        lastCell = _ref4.lastCell,
        rowIndex = _ref4.rowIndex,
        columnIndex = _ref4.columnIndex,
        columnWidth = _ref4.columnWidth;
    return {
      boxSizing: 'content-box',
      display: 'flex',
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: 'auto',
      width: columnWidth + 'px',
      padding: '12px 16px',
      backgroundColor: 'inherit',
      fontSize: 14
    };
  }
};
export var variants = {
  condensed: {
    headerCell: {
      padding: '0 8px'
    },
    bodyRow: {
      minHeight: '40px'
    },
    bodyCell: {
      padding: '0 8px'
    },
    bodySubRow: {
      minHeight: '28px'
    },
    bodySubCell: {
      padding: '4px 8px'
    }
  }
};